export default {
    brand: {
        product_name: 'FleetHub24',
        tagline:      'Tracker capture',
    },
    nav: {
        map:           'Map',
        vehicles:      'Vehicles',
        drivers:       'Drivers',
        costs:         'Costs',
        trips:         'Trips',
        stats:         'Statistics',
        zones:         'Zones',
        alerts:        'Alerts',
        reminders:     'Reminders',
        reports:       'Reports',
        install_guide: 'Installation guide',
        configuration: 'Configuration',
        settings:      'Account and users',
        collapse:      'Collapse menu',
        expand:        'Expand menu',
        version_web:   'Console {version}',
        version_api:   'API {version}',
        organizations: 'Organisations',
        service:        'Service',
        out_of_service: 'Vehicles out of service',
        service_cases:  'Service cases',
        assigned_cases: 'Assigned cases',
        part_orders:    'Part orders',
    },
    general: {
        add:      'Add',
        edit:     'Edit',
        cancel:   'Cancel',
        save:     'Save',
        close:    'Close',
        refresh:  'Refresh',
        filter:   'Filter',
        search:   'Search',
        loading:  'Loading …',
        copy:     'Copy',
        copied:   'Copied',
        none:     '—',
        settings: 'Settings',
        confirm:  'Confirm',
        delete:   'Delete',
        sign_out: 'Sign out',
    },
    auth: {
        login:     'Sign in',
        username:  'Username',
        password:  'Password',
        sign_in:   'Sign in',
        failed:    'Sign-in failed',
        signed_in: 'Signed in as {name}',
        or:            'or',
        password_show: 'Show the password',
        password_hide: 'Hide the password',
    },
    settings: {
        settings:    'Settings',
        subtitle:    'Your account, the people who may open this console, and the keys you sign in with.',
        account:     'Account',
        reader_note: 'You are signed in as a reader: you can see everything in this console and change nothing. An administrator makes the changes.',
    },
    password: {
        change:        'Change password',
        current:       'Current password',
        new:           'New password',
        repeat:        'Repeat the new password',
        mismatch:      'The two passwords do not match',
        wrong_current: 'That is not your current password',
        changed:       'Your password has been changed',
        failed:        'The password could not be changed',
    },
    user: {
        users:              'Users',
        subtitle:           'Everybody who may open this console.',
        add:                'Add a user',
        edit:               'Edit the user',
        delete:             'Delete the user',
        name:               'Name',
        username:           'Username',
        role:               'Role',
        role_admin:         'Administrator',
        role_reader:        'Reader',
        role_help:          'A reader sees everything and changes nothing; an administrator also edits vehicles and manages accounts.',
        created:            'Created',
        password:           'Password',
        password_optional:  'New password',
        password_rule:      'At least 12 characters. Length is what costs an attacker — no digits or symbols are required.',
        password_keep:      'Leave it empty to keep the current password.',
        password_too_short: 'The password must be at least 12 characters',
        username_too_short: 'At least 3 characters',
        name_too_long:      'At most 64 characters',
        username_taken:     'Somebody already has that username',
        last_admin:         'The last administrator cannot be deleted or made a reader',
        cannot_delete_self: 'You cannot delete your own account',
        confirm_delete:     'Delete the account of {name}? Their passkeys go with it.',
        deleted:            'The account was deleted',
        delete_failed:      'The account could not be deleted',
        empty:              'There are no accounts.',
        you:                'you',
        organization:      'Organisation',
        organization_help: 'The organisation an account belongs to decides what it sees; the role decides what it may change.',
    },
    organization: {
        organizations:   'Organisations',
        subtitle:        'The operator, the customers whose fleets he looks after, and the workshops that maintain them.',
        add:             'Add organisation',
        edit:            'Edit organisation',
        kind:            'Kind',
        all_kinds:       'All kinds',
        search:          'Search by name, tax ID or city',
        empty:           'No organisations.',
        inactive:        'inactive',
        name:            'Name',
        customer_type:   'Fleet type',
        tax_id:          'Tax ID',
        address:         'Address',
        city:            'City',
        country:         'Country',
        country_help:    'Two-letter code, e.g. HR',
        lat:             'Latitude',
        lon:             'Longitude',
        contact:         'Contact',
        contact_email:   'Contact e-mail',
        contact_phone:   'Contact phone',
        active:          'Active',
        active_help:     'An inactive organisation is kept, but its people can no longer sign in.',
        kind_operator:   'Operator',
        kind_customer:   'Customer',
        kind_workshop:   'Workshop',
        type_rent_a_car: 'Rent-a-car',
        type_transport:  'Transport',
        type_machinery:  'Machinery',
        type_other:      'Other',
        switcher:        'Customer in view',
        all_customers:   'All customers',
    },
    portal: {
        operator: 'Stanić — management',
        customer: 'Fleet — customers',
        workshop: 'Service — partners',
    },
    passkey: {
        passkeys:       'Passkeys',
        subtitle:       'The keys you sign in with — a phone, a laptop, a hardware key.',
        add:            'Add a passkey',
        continue:       'Continue',
        delete:         'Remove the passkey',
        name:           'Name',
        name_help:      'Name it after the device it lives on, so you can tell later which one to remove.',
        name_too_long:  'At most 60 characters',
        default_name:   'This device',
        created:        'Added',
        last_used:      'Last used',
        never_used:     'never used',
        added:          'The passkey was added',
        removed:        'The passkey was removed',
        failed:         'The passkey could not be added',
        delete_failed:  'The passkey could not be removed',
        confirm_delete: 'Remove the passkey "{name}"? You will not be able to sign in with it again.',
        empty:          'You have not added a passkey yet.',
        sign_in:        'Sign in with a passkey',
        sign_in_failed: 'That passkey was not accepted',
        unavailable:    'Passkeys are switched off on this deployment — they need a domain of its own over HTTPS.',
        unsupported:    'This browser cannot use passkeys. They need a secure connection (HTTPS).',
    },
    service_key: {
        keys:             'API keys',
        subtitle:         'Keys other systems sign in to this console with — the company portal first of all. Every key has administrator rights.',
        add:              'New key',
        add_help:         'Name it after the system that will use it, so you know later which one to revoke.',
        name:             'Name',
        name_placeholder: 'Portal',
        name_too_long:    'At most 64 characters',
        create:           'Create key',
        prefix:           'Key starts with',
        created:          'Created',
        last_used:        'Last used',
        never_used:       'not used yet',
        status:           'Status',
        active:           'Active',
        revoked:          'Revoked',
        environment:      'From environment',
        environment_name: 'Environment key {n}',
        environment_note: 'Environment keys are set in the SERVICE_API_KEYS variable in /opt/stanic-fleet/.env on the server. They cannot be revoked here — remove them from that file and redeploy stanic-api.',
        revoke:           'Revoke',
        revoke_title:     'Revoke key',
        revoke_confirm:   'Revoke key',
        confirm_revoke:   'Revoke the key “{name}” ({prefix}…)? The system using it will no longer be able to sign in with it. This cannot be undone.',
        revoked_toast:    'The key has been revoked',
        revoke_failed:    'The key could not be revoked',
        created_toast:    'The key has been created',
        create_failed:    'The key could not be created',
        empty:            'There are no API keys yet.',
        result_title:     'New API key: {name}',
        result_once:      'This key is shown only now',
        result_warning:   'Copy it and store it in the system that will use it. It cannot be shown again — if you lose it, revoke it and create a new one.',
        result_usage:     'Authorization: Bearer <key>',
        done:             'I have saved the key, close',
    },
    layout: {
        open_menu:  'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    density: {
        label:   'Density',
        compact: 'Compact',
        normal:  'Normal',
    },
    locale: {
        label: 'Language',
        en:    'English',
        sl:    'Slovenian',
        hr:    'Croatian',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'Not authorized',
        forbidden:     'Not allowed',
        on_add:        'Error while adding',
        on_edit:       'Error while saving',
        on_load:       'The data could not be loaded',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully saved',
    },
    validation: {
        required: 'This field is required',
    },
    time: {
        now:     'now',
        never:   'never',
        minutes: '{count} min',
        hours:   '{count} h',
        days:    '{count} d',
        ago:     '{value} ago',
    },
    device: {
        devices:        'Devices',
        device:         'Device',
        imei:           'IMEI',
        state:          'State',
        online:         'Online',
        offline:        'Offline',
        first_seen:     'First seen',
        last_seen:      'Last seen',
        last_record:    'Last record',
        last_position:  'Last position',
        last_speed:     'Last speed',
        record_count:   'Records',
        packet_count:   'Packets',
        counts:         'Records / packets',
        empty_title:    'No device has connected yet',
        empty_body:     'The server listens on TCP port 5027 (Codec 8 Extended). A device appears here as soon as it sends its first packet — it identifies itself with its IMEI, then sends records.',
        not_found:      'There is no device with that IMEI',
        auto_refresh:   'Auto-refresh',
        refresh_every:  'Refreshes every {seconds} s',
        waiting:        'Waiting',
        waiting_title:  'Waiting for its first packet',
        waiting_body:   'The vehicle is on file; its tracker has not reported yet. The moment it sends its first packet, the times, the position and the parameters appear here — until then there is nothing to show.',
        asleep:         'asleep',
        sleep_none:     'no sleep',
        sleep_gps:      'GPS sleep',
        sleep_deep:     'deep sleep',
        sleep_online:   'online sleep',
        sleep_ultra:    'ultra sleep',
    },
    driver: {
        drivers:              'Drivers',
        subtitle:             'The people the logbook and the vehicle assignments name.',
        add:                  'Add a driver',
        edit:                 'Edit driver',
        name:                 'Full name',
        phone:                'Phone',
        email:                'E-mail',
        employee_no:          'Employee no.',
        tag:                  'Fob identifier',
        tag_help:             'For later automatic driver recognition (iButton, RFID or Bluetooth fob). Not used yet.',
        note:                 'Note',
        active:               'Active',
        inactive:             'Inactive',
        show_inactive:        'Show inactive',
        search:               'Search by name, phone or employee number …',
        vehicles:             'Vehicles',
        empty:                'No drivers yet.',
        unknown:              'Unknown driver',
        delete:               'Delete driver',
        confirm_delete:       'Delete the driver {name}?',
        confirm_keeps:        'This driver appears in the logbook, so they will be deactivated rather than erased.',
        deleted:              'The driver has been taken off the list.',
        delete_failed:        'The driver could not be deleted',
        tag_taken:            'That fob identifier already belongs to another driver.',
        name_too_long:        'At most 80 characters',
        phone_invalid:        'Enter a phone number — digits, spaces and + - / ( ).',
        email_invalid:        'Enter a valid e-mail address.',
        employee_no_too_long: 'At most 32 characters',
        tag_too_long:         'At most 64 characters',
        note_too_long:        'At most 200 characters',
    },
    vehicle: {
        photo_pick:     'Upload a photo',
        photo_clear:    'Remove the photo',
        photo_drop:     'Drop a photo here, or pick one — JPEG, PNG or WebP',
        photo_failed:   'The upload could not be stored',
        drivetrain:      'Drivetrain',
        drivetrain_auto: 'Work it out from the data',
        drivetrain_ice:  'Combustion',
        drivetrain_ev:   'Electric',
        drivetrain_phev: 'Plug-in hybrid',
        drivetrain_help: 'Leave it on the first option for a vehicle that is already sending — what it reports beats what anybody remembers.',
        vehicle:        'Vehicle',
        edit:           'Edit vehicle',
        name:           'Name',
        plate:          'Registration plate',
        body:           'Body',
        colour:         'Colour',
        colour_help:    'Pick one of the presets or type a hex value.',
        colour_invalid: 'Use a hex colour such as #1e4fa3',
        name_too_long:  'At most 64 characters',
        plate_too_long: 'At most 16 characters',
        add:                  'Add a vehicle',
        added:                'The vehicle has been added.',
        add_failed:           'The vehicle could not be added',
        imei:                 'Tracker IMEI',
        imei_help:            'Fifteen digits from the label on the tracker; Teltonika Configurator shows the same IMEI.',
        imei_length:          'An IMEI has 15 digits.',
        imei_invalid:         'This IMEI is not valid — check the last digit.',
        imei_exists:          'A vehicle with this IMEI already exists.',
        imei_authorises:      'This allows the tracker with this IMEI to connect.',
        name_required:        'Give the vehicle a name.',
        delete:               'Delete the vehicle',
        delete_blocks:        'This vehicle’s tracker will no longer be able to connect.',
        delete_keeps:         'The data is kept; add a vehicle with the same IMEI again and it reappears.',
        delete_purge:         'Also delete all of this vehicle’s data (records, tracks, logbook, alerts). This cannot be undone.',
        delete_confirm_plate: 'Type the registration plate to confirm.',
        delete_confirm_imei:  'Type the last six digits of the IMEI to confirm.',
        deleted:              'The vehicle has been deleted.',
        delete_failed:        'The vehicle could not be deleted',
        empty_add:            'Add a vehicle to allow its tracker to connect.',
        driver:                'Driver',
        no_driver:             'No driver',
        assign_driver:         'Assign a driver',
        driver_since:          'In force from',
        driver_since_now:      'From now',
        driver_since_choose:   'Pick another moment',
        driver_assigned:       'The driver has been assigned.',
        driver_failed:         'The driver could not be assigned',
        driver_history:        'Driver history',
        driver_history_empty:  'This vehicle has never had a driver assigned.',
        driver_from:           'from {from}',
        driver_to:             'to {to}',
        driver_now:            'now',
        driver_show_all:       'Show all',
        driver_show_less:      'Show fewer',
        purchase_value:     'Acquisition value (incl. VAT)',
        purchase_help:      'What the vehicle cost including VAT — the base the benefit in kind is a percentage of. For a lease, the owner\'s value; for a used car, what the company actually paid.',
        purchase_currency:  'Currency',
        first_use:          'First use date',
        first_use_help:     'The day the employer acquired the vehicle — not its first registration. The yearly reduction is counted from it.',
        employer_fuel:      'The employer pays for fuel on private drives',
        employer_fuel_help: 'The benefit then rises by a quarter.',
        benefit_user:       'Vehicle user',
        benefit_user_help:  'The employee who has the vehicle for private use. Empty means the currently assigned driver.',
        fuel_type:          'Fuel type',
        fuel_type_none:     'Not stated',
        fuel_petrol:        'Petrol',
        fuel_diesel:        'Diesel',
        fuel_lpg:           'LPG',
        fuel_electric:      'Electric',
        fuel_hybrid:        'Hybrid',
        fuel_phev:          'Plug-in hybrid',
        finance:            'Finance',
        finance_help:       'Visible to administrators only. Empty fields change nothing.',
        finance_saved:      'The finance details have been saved.',
        customer:          'Customer',
        customer_help:     'Whose fleet the vehicle is in. Only that customer\'s people see it.',
        customer_pick:     'Choose a customer',
        customer_required: 'Choose a customer',
        no_customer:       'No customer',
        move_in_service:   'The vehicle has an open service case. Close or cancel the case before moving the vehicle to another customer.',
    },
    tracker: {
        model:            'Tracker',
        model_help:       'Which Teltonika tracker is in the vehicle — it decides what each value means. Left unset, it is read as an FMC003.',
        unknown:          'Not recorded (read as an FMC003)',
        line:             'Tracker: {model} · {family}',
        family_obd:       'OBD dongle',
        family_light_can: 'Light vehicles (CAN)',
        family_heavy:     'Trucks and machinery (FMS)',
        engine_hours:     'Engine hours',
        hours_unit:       'h',
    },
    body: {
        unknown:   'Not set',
        sedan:     'Saloon',
        estate:    'Estate',
        hatchback: 'Hatchback',
        suv:       'SUV',
        van:       'Van',
        pickup:    'Pickup',
        truck:     'Truck',
    },
    tab: {
        map:        'Map',
        parameters: 'Parameters',
        records:    'Records',
        packets:    'Raw packets',
        graphs:     'Graphs',
    },
    graph: {
        speed:        'Speed against the limit',
        rpm:          'Engine speed',
        temperatures: 'Temperatures',
        battery:      'Battery',
        fuel:         'Fuel',
        consumption:  'Consumption',
        power:        'Pack power',
        level:        'Level',
        average_consumption: 'Average consumption',
        limit:        'Posted limit',
        over_limit:   'Over the limit',
        charging:     'Charging',
        empty:        'Nothing was recorded in this period.',
        not_reported: 'The vehicle does not report: {names}.',
        window_fit:   'Fit to the drives',
        window_all:   'Show the whole period',
        window_fitted: 'fitted to the drives',
        window_earlier: 'Move back',
        window_later: 'Move forward',
        window_hint:  'Drag to zoom in, wheel to scale, Home for the whole period.',
    },
    fleet_map: {
        title:            'Map',
        all:              'All',
        driving:          'Driving',
        stopped:          'Stopped',
        asleep:           'Asleep',
        offline:          'No signal',
        alerting:         'With an alert',
        search:           'Search by name, plate, IMEI or place …',
        badge_moving:     'Driving',
        badge_stopped:    'Stopped',
        badge_asleep:     'Asleep',
        badge_offline:    'No signal',
        badge_never_seen: 'Never seen',
        state_moving:     'Driving for {duration}',
        state_stopped:    'Stopped for {duration}',
        state_asleep:     'Asleep for {duration}',
        state_offline:    'No signal for {duration}',
        state_never_seen: 'Never seen yet',
        over_a_day:       'More than 24 h',
        days:             '{count} day | {count} days',
        open:             'Open',
        fit:              'Fit to all vehicles',
        refreshed:        'last refreshed {ago}',
        empty:            'No vehicle matches the filter.',
        no_positions:     'No vehicle has a known position yet.',
        hide_list:        'Hide the list',
        show_list:        'Show the list',
        unsupported:      'This version of the API does not know the fleet map yet. Everything else in the console works as before.',
        to_vehicles:      'Open the vehicle list',
        driver:           'Driver',
        centre_selected: 'Centre on the selected vehicle',
        live_routes:     'Show the routes of moving vehicles',
        drive_distance:  'This drive so far: {km} km',
    },
    logbook: {
        title:               'Logbook',
        business:            'Business',
        private:             'Private',
        unclassified:        'Unclassified',
        kind:                'Kind of drive',
        purpose:             'Purpose',
        driver:              'Driver',
        odometer:            'Odometer',
        tracker_odometer:    'the tracker’s counter, not the vehicle’s',
        gps_distance:        'Measured distance: {km} km',
        edit:                'Edit entry',
        edit_trip:           'Edit the entry for {route}',
        saved:               'Saved',
        save_failed:         'The entry could not be saved.',
        keep:                'Leave as is',
        bulk_title:          'Classify the selected drives',
        bulk_help:           'Fields left empty leave the existing entries alone.',
        select:              'Select drive',
        select_day:          'Select the whole day',
        selected:            'Selected: {count}',
        mark_business:       'Mark as business',
        mark_private:        'Mark as private',
        set_purpose:         'Purpose…',
        clear_selection:     'Clear the selection',
        export:              'Export CSV',
        export_failed:       'The export could not be prepared.',
        filter:              'Kind of drive',
        all_kinds:           'All',
        filter_business:     'Business',
        filter_private:      'Private',
        filter_unclassified: 'Unclassified',
        totals:              'business {business} km · private {private} km · unclassified {unclassified} km',
        threshold_note:      'The logbook is defined at the 30 min threshold; classifying is not possible at another one.',
        purpose_too_long:    'The purpose is too long.',
        driver_too_long:     'The driver’s name is too long.',
        from_assignment:     'from the assignment',
        driver_filter:       'Driver',
        all_drivers:         'All drivers',
        driver_pick:         'Pick a driver or type a name',
        driver_help:         'Pick a driver from the register, or type the name of an external one.',
    },
    trips_page: {
        title:        'Trips',
        period:       'Period',
        today:        'Today',
        yesterday:    'Yesterday',
        last_7:       'Last 7 days',
        last_30:      'Last 30 days',
        custom:       'Custom',
        range:        'From–to',
        vehicles:     'Vehicles',
        all_vehicles: 'All vehicles',
        stop_label:   'A trip ends after',
        totals:       'Total: {trips} trips · {km} km · {time} driving',
        day_totals:   '{trips} trips · {km} km · {time}',
        empty:        'No trips in the selected period.',
        select_trip:  'Pick a trip to see it on the map.',
        open_vehicle: 'Open vehicle',
        fold_all:     'Collapse all',
        unfold_all:   'Expand all',
        fold_day:     'Collapse {day}',
        unfold_day:   'Expand {day}',
    },
    gps: {
        latitude:   'Latitude',
        longitude:  'Longitude',
        altitude:   'Altitude',
        angle:      'Heading',
        satellites: 'Satellites',
        speed:      'Speed',
        valid:      'Valid fix',
        invalid:    'No fix',
        no_fix:     'The device has not sent a valid position fix yet.',
    },
    track: {
        title:               'Track',
        period:              'Period',
        last_hour:           'Last hour',
        last_day:            'Last 24 h',
        last_week:           'Last 7 days',
        points:              '{count} points',
        empty:               'No valid position fixes in the selected period.',
        attribution:         '© OpenStreetMap contributors',
        attribution_tomtom:  '© TomTom',
        attribution_traffic: 'Traffic © TomTom',
        zoom:                'Zoom {zoom}',
        zoom_in:             'Zoom in',
        zoom_out:            'Zoom out',
        fit:                 'Fit the track',
        centre_vehicle:      'Centre vehicle',
        traffic:             'Traffic',
        traffic_legend:      'The traffic layer colours every road by how freely it is moving — green flows, amber slows, red crawls and dark red stands still. It is fetched again every couple of minutes.',
        speed_chart:         'Speed',
        chart_show:          'Show the speed graph',
        chart_hide:          'Hide the speed graph',
    },
    cost: {
        title:             'Costs',
        add:               'Add a cost',
        edit:              'Edit cost',
        added:             'The cost has been added.',
        saved:             'The cost has been saved.',
        deleted:           'The cost has been deleted.',
        save_failed:       'The cost could not be saved',
        delete_failed:     'The cost could not be deleted',
        delete_confirm:    'Delete this cost? Its receipt goes with it.',
        empty:             'No costs in the chosen period.',
        export:            'Export CSV',
        export_failed:     'The export could not be prepared',
        cat_fuel:          'Fuel',
        cat_charging:      'Charging',
        cat_service:       'Service',
        cat_tyres:         'Tyres',
        cat_insurance:     'Insurance',
        cat_registration:  'Registration',
        cat_vignette:      'Vignette',
        cat_toll:          'Toll',
        cat_parking:       'Parking',
        cat_wash:          'Wash',
        cat_fine:          'Fine',
        cat_leasing:       'Leasing',
        cat_other:         'Other',
        tab_costs:         'Costs',
        tab_overview:      'Overview',
        period:            'Period',
        range:             'Custom range',
        this_month:        'This month',
        last_month:        'Last month',
        this_year:         'This year',
        last_12:           'Last 12 months',
        custom:            'Custom',
        all_vehicles:      'All vehicles',
        all_categories:    'All categories',
        all_drivers:       'All drivers',
        vehicle:           'Vehicle',
        date:              'Date',
        category:          'Category',
        amount:            'Amount',
        currency:          'Currency',
        vat_rate:          'VAT rate',
        vat_none:          'Not stated',
        quantity:          'Quantity',
        unit:              'Unit',
        unit_price:        'Unit price',
        full_tank:         'Full tank',
        full_tank_help:    'Consumption can only be measured honestly between two full tanks — what goes in between them is exactly what was burnt.',
        odometer:          'Odometer',
        odometer_help:     'Suggested from what the vehicle reported that day. You can correct it.',
        odometer_unknown:  'The vehicle reported no odometer reading that day.',
        supplier:          'Supplier',
        document_no:       'Document no.',
        note:              'Note',
        driver:            'Driver',
        receipt:           'Receipt',
        receipt_pick:      'Upload a receipt',
        receipt_open:      'Open the receipt',
        receipt_clear:     'Remove the receipt',
        receipt_drop:      'Drag a receipt here or pick one — JPEG, PNG, WebP or PDF, up to 5 MB',
        receipt_failed:    'The receipt could not be saved',
        receipt_saved:     'The receipt is attached.',
        receipt_removed:   'The receipt has been removed.',
        receipt_after:     'A receipt can be attached once the cost is saved.',
        load_older:        'Load older',
        total:             'Total',
        records:           '{count} records',
        mixed_currency:    'These costs are in more than one currency; this console converts nothing, so the total is only a sum of numbers.',
        overview:          'Overview',
        by_month:          'By month',
        per_km:            'Cost per km',
        consumption:       'Consumption',
        consumption_approx: 'Approximate — an electric vehicle cannot be measured between two full charges, so this is all the energy over the distance driven.',
        km_driven:         'Kilometres driven',
        km_odometer:       'from the vehicle\'s own odometer',
        km_trips:          'from the GPS distance of its drives',
        km_unknown:        'The vehicle reported no distance, so a cost per kilometre cannot be computed.',
        no_data:           'Nothing to show in this overview.',
        amount_invalid:    'Enter an amount, for example 45.90',
        amount_ambiguous:  'This amount cannot be read — 1,234 is either 1.234 or 1234. Write 1234.00 or 1.23.',
        quantity_invalid:  'Enter a quantity, for example 41.37',
        quantity_required: 'Fuel and charging need a quantity.',
        vehicle_required:  'Choose a vehicle.',
        from_reminder:     'from a reminder',
        open_reminders:    'Open this vehicle’s reminders',
    },
    stats: {
        title:                'Statistics',
        export:               'Export CSV',
        export_failed:        'The export could not be prepared',
        failed:               'The statistics could not be loaded.',
        period:               'Period',
        range:                'Custom period',
        this_month:           'This month',
        last_month:           'Last month',
        last_7:               'Last 7 days',
        last_30:              'Last 30 days',
        custom:               'Custom',
        all_vehicles:         'All vehicles',
        vehicles:             'Vehicles',
        all_drivers:          'All drivers',
        driver_filter:        'Driver',
        speeding_check:       'Check for speeding',
        window_note:          'Statistics cover at most {days} days: drives are recomputed from the position records every time, so the period is limited as on the Trips page.',
        window_clamped:       'The chosen period is longer than {days} days, so the last {days} days are shown.',
        tab_vehicles:         'By vehicle',
        tab_drivers:          'By driver',
        tab_days:             'By day',
        drives:               'Drives',
        drives_count:         '{count} drive | {count} drives',
        no_drives:            'no drives',
        vehicles_moved:       'vehicles that moved: {moved} of {vehicles}',
        km:                   'Kilometres',
        km_split:             'business {business} · private {private} · unclassified {unclassified}',
        business_km:          'Business km',
        private_km:           'Private km',
        unclassified_km:      'Unclassified km',
        driving_time:         'Driving time',
        days_in_window:       '{days} day in the period | {days} days in the period',
        costs:                'Costs',
        costs_note:           'from the cost register, for the days of the period',
        no_costs:             'no costs recorded in the period',
        cost_per_km:          'Cost per km',
        per_km_fleet:         'vehicles with known kilometres',
        per_km_driver:        'over the kilometres the driver drove',
        truncated:            'A vehicle sent more records in this period than can be read at once, so its oldest drives are missing. Choose a shorter period.',
        speeding_unavailable: 'Speed limits could not be obtained, so speeding was not checked.',
        speeding_found:       'Speeding: {events} in {checked} of {drives} drives.',
        speeding_stopped:     'Limits were not available for the next drive, so the check stopped.',
        speeding_capped:      'The check is limited per request; choose a shorter period or one vehicle for the rest.',
        speeding_partial:     '{checked} of {drives} drives checked',
        speeding_footnote:    'A speeding event is at least two consecutive records more than {tolerance} km/h over the limit — a GPS trace matched to a map, not evidence.',
        footnote:             'Kilometres come from the vehicle\'s odometer where it reported one, otherwise from the GPS distance. A drive counts on the day it started; a drive still under way is not counted. Average speed leaves out stops during a drive.',
        sort_by:              'Sort by: {column}',
        empty:                'No data for the chosen period.',
        vehicle:              'Vehicle',
        driver:               'Driver',
        no_driver:            'No driver',
        external_driver:      'external driver',
        vehicles_driven:      'Vehicles',
        average_speed:        'Avg km/h',
        max_speed:            'Max km/h',
        speeding:             'Speeding',
        stops:                'Stops',
        consumption:          'Consumption',
        odometer:             'Odometer (km)',
        odometer_tracker:     'tracker counter',
    },
    day: {
        pick:          'Day…',
        previous:      'Previous day',
        next:          'Next day',
        clear:         'Back to the period',
        legend:        'Days in bold are days the vehicle drove.',
        view_trips:    'Trips',
        view_day:      'Day',
        start:         'Start',
        end:           'End',
        drives:        '{count} drives',
        stops:         '{count} stops',
        driving:       'driving {duration}',
        parked_before: 'Standing since before',
        still_parked:  'Still standing',
        still_driving: 'Still driving',
        speed_chart:   'Speed through the day',
        no_data:       'Nothing was recorded on this day.',
        no_driving:    'The vehicle did not drive on this day.',
        moving:        'driving',
        standing:      'standing',
    },
    parameter: {
        parameters:  'Parameters',
        id:          'ID',
        name:        'Name',
        group:       'Group',
        count:       'Records',
        last_value:  'Last value',
        last_seen:   'Last seen',
        unknown:     'unknown parameter',
        filter:      'Filter by name or ID …',
        empty:       'No parameters recorded for this device yet.',
        group_obd:   'OBD',
        group_oem:   'OEM',
        group_other: 'Device',
        vehicle_hint: 'The OBD and OEM parameters are the vehicle data this capture exists to discover.',
        hide_empty_slots:   'Hide empty slots',
        no_sensor:          'no sensor',
        hidden_empty_slots: 'Hidden empty slots: {count}',
    },
    record: {
        records:     'Records',
        ts:          'Device time',
        received_at: 'Received',
        priority:    'Priority',
        event:       'Event',
        periodic:    'periodic',
        position:    'Position',
        speed:       'Speed',
        io:          'IO elements',
        io_id:       'ID',
        io_name:     'Name',
        io_size:     'Bytes',
        io_value:    'Value',
        io_hex:      'Hex',
        io_text:     'Text',
        io_empty:    'This record carries no IO elements.',
        load_older:  'Load older',
        no_more:     'No older records',
        empty:       'The device has not sent any records yet.',
        newest_first: 'Newest first',
        asleep_hint: 'The tracker is asleep — its GNSS receiver is off, so there is no position fix.',
    },
    priority: {
        low:   'low',
        high:  'high',
        panic: 'panic',
    },
    packet: {
        packets:      'Raw packets',
        codec:        'Codec',
        codec_8:      'Codec 8',
        codec_8e:     'Codec 8E',
        record_count: 'Records',
        state:        'Decoded',
        decoded:      'Decoded',
        failed:       'Failed',
        remote_addr:  'Device address',
        received_at:  'Received',
        raw_hex:      'Raw bytes',
        show_hex:     'Show bytes',
        hide_hex:     'Hide bytes',
        empty:        'No packets stored for this device.',
        bytes:        '{count} B',
    },
    gauges: {
        show: 'Instruments',
        hide: 'Hide the instruments',
        title:        'Instruments',
        as_of:        'Last values · {when}',
        no_data:      'The device has not sent any data yet',
        ignition_on:  'Ignition on',
        ignition_off: 'Ignition off',
        speed:        'Speed',
        rpm:          'Engine speed',
        coolant:      'Coolant',
        fuel:         'Fuel',
        load:         'Engine load',
        voltage:      'Battery',
        soc:          'Battery',
        charging:     'Charging',
        not_charging: 'Not plugged in',
        battery_temp: 'Battery temp.',
        hv_voltage:   'Battery voltage',
        hv_current:   'Battery current',
        soh:          'Battery health',
        range:        'Range',
        energy:       'Energy in battery',
        consumption:  'Consumption',
        lifetime_use: 'Lifetime use',
        fuel_litres:  'Fuel (OEM)',
        until_service: 'Until service',
        odometer_oem: 'Vehicle odometer (OEM)',
        odometer_gps: 'Tracker odometer (GPS)',
        hint:         'A greyed-out dial means the vehicle does not report that value.',
        stale_hint:   'A dimmed dial shows the last value from before the vehicle stopped sending it (e.g. after the ignition was switched off).',
        stale_at:     'at {time}',
        stale_title:  'Last value at {time} — the vehicle is not sending this right now.',

        style_analogue: 'Dials',
        style_digital:  'Cluster',
        drivetrain_ev:  'Electric',
        drivetrain_ice: 'Combustion',
        vin:            'VIN',
        trip:           'trip',
        range_of:       '{value} range',
        power_derived:  'Power draw (V × A)',
        pack:           'HV pack',
        charging_state: 'Charging',
        intake_air:     'Intake air',
        fault_codes:    'Fault codes',
        movement:       'Movement',
        moving:         'Moving',
        stopped:        'Stopped',
        tracker:        'Tracker',
        gsm:            'GSM',
        satellites:     'sat',
    },
    speeding: {
        check:        'Speed limits',
        found:        '{count} stretches over the limit',
        none:         'Nothing over the limit',
        matched:      '{matched} of {total} fixes matched a road with a posted limit',
        limit_was:    'limit {limit}',
        unnamed_road: 'unnamed road',
        unavailable:  'Road limits could not be fetched — nothing is flagged.',
        disclaimer:   'Indicative: a GNSS trace matched to a crowd-sourced map, not evidence.',
    },
    trip: {
        found:             'Trips: {count}',
        none:              'No trips in this period',
        stop_label:        'A trip ends after',
        out:               'out',
        back:              'back',
        open:              'in progress',
        max_speed:         'max {speed} km/h',
        stops:             'stops: {count}',
        name_start:        'Name the start',
        name_end:          'Name the destination',
        names_unavailable: 'Place names could not be read from the map — coordinates are shown instead.',
        truncated:         'This period holds more fixes than were read: the oldest trips are missing.',
        rule:              'A trip ends once the vehicle has stood for at least {minutes} min.',
        presentation:      'Presentation',
        open_replay:       'This drive has not ended yet (the vehicle has to stand for {minutes} min). It replays up to {time}.',
    },
    replay: {
        play:           'Play the drive',
        pause:          'Pause',
        restart:        'Back to the start',
        speed:          'Playback speed',
        follow:         'Follow the vehicle',
        scrubber:       'Drive playback',
        stop:           'stopped {duration}',
        badge:          'Replay',
        playing:        'Playing',
        drive_of:       'drive {n} of {total}',
        continue:       'Continue to the next drive',
        next_drive:     'Next drive',
        previous_drive: 'Previous drive',
        loading_next:   'Loading the next drive…',
    },
    zone: {
        title:                 'Zones',
        subtitle:              'The same circles that name a trip are the zones the alarm rules are written against.',
        add:                   'New zone',
        empty:                 'No zone has been drawn yet.',
        map_empty:             'Draw the first zone to see it on the map.',
        edit_help:             'Click the map for the centre, drag the edge for the radius.',
        edit_on_map:           'Edit on the map',
        name:                  'Name',
        name_too_long:         'The name is too long.',
        kind:                  'Kind',
        kind_place:            'Place',
        kind_depot:            'Depot',
        kind_customer:         'Customer',
        kind_restricted:       'Restricted area',
        radius:                'Radius',
        radius_range:          'The radius must be between 25 and 2000 m.',
        note:                  'Note',
        note_too_long:         'The note is too long.',
        saved:                 'The zone has been saved.',
        created:               'The zone has been added.',
        save_failed:           'The zone could not be saved.',
        delete:                'Delete zone',
        delete_confirm:        'Delete the zone "{name}"? Trips will carry the settlement\'s name again.',
        delete_forced_confirm: 'Delete it anyway and take it out of them?',
        deleted:               'The zone has been deleted.',
        delete_failed:         'The zone could not be deleted.',
        in_use:                'The zone cannot be deleted because alarm rules use it.',
        used_by:               'These rules use the zone: {names}.',
        no_rules:              'No rule uses this zone.',
        no_zones:              'No zones',
        search:                'Search by name or note …',
        clear_search:          'Clear search',
        match_count:           '{n} of {total}',
        no_match:              'No zone matches “{q}”.',
        on_map_count:          '{n} on the map',
        on_map:                'On the map: {name}',
        show_on_map:           'Show on the map',
        hide_on_map:           'Hide from the map',
        show_all:              'Show all on the map',
        hide_all:              'Hide all',
        map_default_help:      'By default only the IT Team zones are drawn on the map. The choice is kept in this browser and changes neither the rules nor the trip names.',

        rules:                  'Rules',
        rules_subtitle:         'Rules you write yourself: when the console should report entering, leaving, standing in a zone, driving outside working hours, or speeding inside a zone.',
        rules_empty:            'No rule has been written yet.',
        rule_add:               'New rule',
        rule_edit:              'Edit rule',
        rule_name:              'Rule name',
        rule_type:              'Rule type',
        rule_zones:             'Zones',
        rule_zones_help:        'The rule applies to every zone chosen. 50 at most.',
        rule_zones_placeholder: 'Choose zones',
        rule_vehicles:          'Vehicles',
        rule_vehicles_help:     'Empty means every vehicle.',
        rule_saved:             'The rule has been saved.',
        rule_created:           'The rule has been added.',
        rule_save_failed:       'The rule could not be saved.',
        rule_delete:            'Delete rule',
        rule_delete_confirm:    'Delete the rule "{name}"? Its open alerts will be closed.',
        rule_deleted:           'The rule has been deleted.',
        rule_delete_failed:     'The rule could not be deleted.',
        rule_enabled:           'The rule is on.',
        rule_disabled:          'The rule is off.',

        type_enter:          'Entering a zone',
        type_exit:           'Leaving a zone',
        type_dwell:          'Standing in a zone',
        type_off_hours:      'Driving outside working hours',
        type_speed:          'Speeding inside a zone',
        type_enter_help:     'Reports when a vehicle drives into one of the chosen zones.',
        type_exit_help:      'Reports when a vehicle leaves one of the chosen zones.',
        type_dwell_help:     'Reports when a vehicle has stood in a zone longer than the time set.',
        type_off_hours_help: 'Reports when a vehicle sets off outside working hours. Zones do not count for this type.',
        type_speed_help:     'Reports when a vehicle exceeds the speed set inside a zone, on two consecutive fixes.',

        severity:              'Severity',
        enabled:               'On',
        disabled:              'Off',
        notify_email:          'Send e-mail',
        applies:               'Applies',
        working_time:          'Working time',
        working_time_required: 'Driving outside working hours needs a working time.',
        always:                'always',
        from:                  'From',
        to:                    'To',
        time_zone:             'Time zone',
        day_1:                 'Mon',
        day_2:                 'Tue',
        day_3:                 'Wed',
        day_4:                 'Thu',
        day_5:                 'Fri',
        day_6:                 'Sat',
        day_7:                 'Sun',
        dwell_minutes:         'Standing',
        dwell_help:            'From 5 to 1440 minutes.',
        dwell_range:           'Standing must be between 5 and 1440 minutes.',
        speed_kmh:             'Limit',
        speed_help:            'From 10 to 200 km/h. It applies inside the zone only.',
        speed_range:           'The limit must be between 10 and 200 km/h.',
        zones_required:        'Choose at least one zone.',
        unit_minutes:          'min',
        all_vehicles:          'All vehicles',
        n_vehicles:            '{count} vehicle | {count} vehicles',
        states:                'States',
        events:                'Events',

        said_enter:     'Entered the zone {zone}',
        said_exit:      'Left the zone {zone}',
        said_dwell:     'Standing in the zone {zone} for {value}',
        said_off_hours: 'Drove off outside working hours',
        said_speed:     'Speeding in the zone {zone}: {value} km/h',

        builtin_hint: 'The six built-in checks about the tracker and the vehicle are in the settings.',
        builtin_link: 'Open the alert settings',
    },
    stop_zone: {
        inside:   'Inside the zone {name}',
        outside:  'Not inside any zone',
        checking: 'Checking the zones …',
        edit:     'Edit zone',
        show:     'Show zone',
        add:      'Add zone',
    },
    place: {
        places:         'Named places',
        subtitle:       'A trip that starts or ends inside the circle takes the place\'s name instead of the settlement\'s. A new place is named at the end of a trip, on a vehicle\'s map.',
        empty:          'No place has been named yet.',
        add:            'Name a place',
        edit:           'Edit place',
        delete:         'Delete place',
        delete_confirm: 'Delete the place "{name}"? Trips will carry the settlement\'s name again.',
        deleted:        'The place has been deleted.',
        delete_failed:  'The place could not be deleted.',
        dialog_help:    'Every trip start or destination inside this circle will carry this name.',
        name:           'Name',
        name_too_long:  'The name is too long.',
        radius:         'Radius',
        radius_help:    'From 25 to 2000 m. 150 m is enough for a yard or a car park.',
        radius_range:   'The radius must be between 25 and 2000 m.',
        position:       'Position',
        on_map_hint:    'The same circles are the zones the alarm rules are written against.',
    },
    map_source: {
        title:              'Map sources',
        subtitle:           'Where this console gets its map, its traffic, the names of places and the posted speed limits. The OpenStreetMap sources need nothing; the TomTom ones need a key, typed here once and kept on the server.',
        tiles:              'Base map',
        tiles_help:         'The imagery every map in the console is drawn on.',
        traffic:            'Traffic layer',
        traffic_help:       'Live traffic drawn over the base map, whichever base that is. Needs a TomTom key.',
        place_names:        'Place names',
        place_names_help:   'Who is asked what the place at the start and the end of a trip is called.',
        speed_limits:       'Speed limits',
        speed_limits_help:  'Where the limit a drive is compared against comes from.',
        key:                'TomTom key',
        key_placeholder:    'TomTom API key',
        key_stored:         'A key is stored. Leave empty to keep it.',
        key_server_only:    'The key is stored on the server only and is never sent back to a browser.',
        key_required:       'A TomTom source needs a key. Type one, or choose the OpenStreetMap sources.',
        test:               'Test key',
        test_ok:            'The key works.',
        test_failed:        'The key could not be used.',
        remove_key:         'Remove key',
        remove_key_confirm: 'Remove the stored TomTom key? The map, the traffic layer, the place names and the speed limits all go back to OpenStreetMap.',
        source_osm:         'OpenStreetMap',
        source_nominatim:   'OpenStreetMap Nominatim',
        source_tomtom:      'TomTom',
    },
    alert: {
        title:                  'Alerts',
        subtitle:               'What the console has noticed about the vehicles: a tracker out of its socket, a flat battery, fault codes, a vehicle that has stopped reporting, roaming and overheating.',
        open:                   'Open',
        resolved:               'Resolved',
        all:                    'All',
        empty:                  'No open alerts.',
        empty_resolved:         'No resolved alerts.',
        empty_all:              'No alerts.',
        vehicles:               'Vehicle',
        all_vehicles:           'All vehicles',
        acknowledge:            'Mark as seen',
        acknowledged:           'Marked as seen',
        acknowledged_by:        'seen by {name}',
        opened:                 'Opened {time}',
        resolved_at:            'Resolved {time}',
        load_older:             'Load older',
        no_more:                'No older alerts',
        severity_critical:      'Critical',
        severity_warning:       'Warning',
        severity_info:          'Information',
        rule_unplugged:         'Tracker unplugged',
        rule_low_voltage:       'Low battery voltage',
        rule_fault_codes:       'Vehicle fault codes',
        rule_silent:            'Vehicle not reporting',
        rule_roaming:           'Roaming',
        rule_overheating:       'Tracker overheating',
        rule_unplugged_help:    'The tracker is no longer being fed by the OBD socket — somebody has pulled it out of the vehicle.',
        rule_low_voltage_help:  'The vehicle\'s 12 V battery at rest, once it has stood still for at least half an hour.',
        rule_fault_codes_help:  'The vehicle reports stored trouble codes (OBD).',
        rule_silent_help:       'The tracker has sent nothing for longer than allowed.',
        rule_roaming_help:      'The SIM is on a foreign network, which makes the data expensive.',
        rule_overheating_help:  'The temperature of the tracker\'s circuit board is too high.',
        said_unplugged:         'The tracker has been unplugged from the OBD socket',
        said_low_voltage:       'The 12 V battery reads {value}',
        said_fault_codes:       'The vehicle reports {count} fault code | The vehicle reports {count} fault codes',
        said_silent:            'No data for {value}',
        said_roaming:           'The tracker is roaming on a foreign network',
        said_overheating:       'Tracker temperature {value}',
        unit_hours:             'h',
        settings_title:         'Alerts',
        settings_subtitle:      'What the console watches for on every vehicle, and who hears about it. The rules run every minute; e-mail goes through a server typed here once and kept on the server.',
        quiet_minutes:          'Quiet period',
        quiet_minutes_help:     'The shortest gap between two messages about the same vehicle and rule, in minutes. A loose connector firing six times an hour then sends one message.',
        mail_title:             'E-mail notifications',
        mail_subtitle:          'One message per event, to every recipient at once and to none of them by name — the addresses travel in the envelope and the message does not disclose them.',
        mail_enabled:           'Send notifications by e-mail',
        mail_incomplete:        'Notifications need a server, a sender and at least one recipient.',
        smtp_host:              'SMTP server',
        smtp_host_placeholder:  'mail.company.com',
        smtp_port:              'Port',
        tls_mode:               'Connection security',
        tls_mode_help:          'STARTTLS is port 587, TLS is port 465. No encryption is only allowed to a server on a private address.',
        tls_starttls:           'STARTTLS',
        tls_tls:                'TLS',
        tls_none:               'None',
        smtp_username:          'Username',
        smtp_username_help:     'Leave empty if the server needs no sign-in.',
        smtp_password:          'Password',
        password_stored:        'A password is stored. Leave empty to keep it.',
        password_server_only:   'The password is stored on the server only and is never sent back to a browser.',
        from_name:              'Sender name',
        from_address:           'Sender address',
        from_address_placeholder: 'fleet@company.com',
        recipients:             'Recipients',
        recipients_help:        'At most 20 addresses. Type one and press enter, or paste several at once.',
        recipients_placeholder: 'address@company.com',
        language:               'Message language',
        language_help:          'The language the notifications are written in. Whoever reads one has no console, so it is decided here.',
        time_zone:              'Time zone',
        time_zone_help:         'The zone every time in a message is written in.',
        console_url:            'Console address',
        console_url_help:       'The address of this console, so a message can link to the vehicle. Empty means no link.',
        console_url_placeholder: 'https://fleet.company.com',
        notify_resolved:        'Send a message when an alert is resolved too',
        test_to:                'Test message to',
        test:                   'Send a test message',
        test_ok:                'The server accepted the message.',
        test_failed:            'The message could not be sent.',
        remove_password:        'Remove password',
        remove_password_confirm: 'Remove the stored SMTP password? If the server needs a sign-in, notifications will stop going out.',
        no_line_breaks:         'This field must not contain a line break.',
        bad_address:            'That is not a valid e-mail address.',
        bad_url:                'The address has to start with http:// or https://.',
        own_rules_hint:         'Your own rules about zones and working hours are on the Alerts page, under the Rules tab.',
        own_rules_link:         'Open the rules',
        rule_reminder_due_soon: 'Reminder coming up',
        rule_reminder_overdue:  'Reminder overdue',
        reminders_enabled:      'Alert on vehicle reminders',
        reminders_notify_email: 'Send e-mail for reminders too',
        reminders_help:         'Registrations, insurance, roadworthiness tests and services are written down per vehicle.',
        reminders_link:         'Open the reminders',
    },
    report: {
        reports:                'Reports',
        subtitle:               'Scheduled e-mail reports: what goes out, to whom, how often and for which period.',
        add:                    'New report',
        edit:                   'Edit report',
        delete:                 'Delete report',
        deleted:                'The report has been deleted.',
        delete_failed:          'The report could not be deleted.',
        confirm_delete:         'Delete the report "{name}"? Its history of sends goes with it.',
        empty:                  'There are no scheduled reports.',
        name:                   'Name',
        name_too_long:          'The name is too long.',
        type:                   'Report type',
        type_logbook:           'Trip logbook',
        type_fleet_summary:     'Fleet summary',
        type_driver_summary:    'Driver summary',
        type_alerts_digest:     'Alerts digest',
        hint_logbook:           'Per-vehicle totals in the message and the logbook for the period attached as CSV — the same file the trips page exports.',
        hint_fleet_summary:     'What each vehicle drove, for how long and with which driver, plus what needs attention.',
        hint_driver_summary:    'The same figures grouped by the driver of each trip rather than by vehicle.',
        hint_alerts_digest:     'Every alert that opened or was resolved in the period, by vehicle — and what is still open.',
        accusative_logbook:     'the trip logbook',
        accusative_fleet_summary: 'the fleet summary',
        accusative_driver_summary: 'the driver summary',
        accusative_alerts_digest: 'the alerts digest',
        frequency:              'Frequency',
        frequency_daily:        'Daily',
        frequency_weekly:       'Weekly',
        frequency_monthly:      'Monthly',
        weekday:                'Day of the week',
        day_of_month:           'Day of the month',
        day_of_month_help:      'From 1 to 28, so that every month has the day — February included.',
        time:                   'Time',
        time_zone:              'Time zone',
        time_zone_help:         'The time is read on this zone\'s clock, the nights it changes included.',
        period:                 'Period',
        period_previous_day:    'Previous day',
        period_previous_week:   'Previous week',
        period_previous_month:  'Previous month',
        period_month_to_date:   'Month to date',
        for_previous_day:       'for the previous day',
        for_previous_week:      'for the previous week (Mon–Sun)',
        for_previous_month:     'for the previous month',
        for_month_to_date:      'for the month to date',
        vehicles:               'Vehicles',
        all_vehicles:           'All vehicles',
        vehicles_help:          'Empty means every vehicle — including the ones added later.',
        drivers:                'Drivers',
        all_drivers:            'All drivers',
        drivers_help:           'Empty means everybody, unclaimed trips included.',
        recipients:             'Recipients',
        recipients_help:        'At most 20 addresses. Type one and press enter.',
        recipients_placeholder: 'address@company.com',
        bad_address:            'That is not a valid e-mail address.',
        need_recipient:         'Add at least one recipient.',
        language:               'Message language',
        attach_csv:             'Attach CSV',
        attach_csv_help:        'The trip logbook is attached as a CSV file.',
        enabled:                'Enabled',
        every_day:              'Every day at {time}',
        every_weekday:          'Every {day} at {time}',
        every_month:            'On the {day} of the month at {time}',
        sentence:               '{when} we send {what} {period} {vehicles} to {recipients}.',
        recipient_count:        '{count} recipient | {count} recipients',
        for_all_vehicles:       'for all vehicles',
        for_some_vehicles:      'for {count} vehicle | for {count} vehicles',
        with_csv:               'With a CSV attachment.',
        next_run:               'Next send',
        last_run:               'Last send',
        never_run:              'Never sent',
        status_sent:            'Sent',
        status_failed:          'Failed',
        status_skipped_no_mail: 'E-mail is not configured',
        send_now:               'Send now',
        send_now_confirm:       'The report "{name}" will be sent to its recipients ({count}) now. Continue?',
        sent:                   'The report has been sent.',
        send_failed:            'The report could not be sent.',
        preview:                'Preview',
        preview_failed:         'The preview could not be built.',
        subject:                'Subject',
        html_part:              'Message',
        plain_part:             'Plain text',
        attachment:             'Attachment',
        download:               'Download',
        no_attachment:          'This report has no attachment.',
        mail_missing:           'E-mail is not configured, so no scheduled report will be sent.',
        mail_missing_link:      'Open the e-mail settings',
        runs:                   'Recent sends',
        no_runs:                'This report has not been sent yet.',
        settings_card:          'Scheduled reports',
        settings_hint:          'The trip logbook, the fleet summary and the alerts digest by e-mail — daily, weekly or monthly.',
        settings_link:          'Open the reports',
        costs:                  'Costs',
        cost_per_km:            'Cost per km',
        no_costs:               'no costs',
        by_category:            'by category',
        costs_hint:             'The report also carries the period’s costs: the total and its split by category, and per vehicle the cost per km. A period with nothing booked says “no costs”.',
    },
    reminder: {
        reminders:              'Reminders',
        subtitle:               'What has to be done to which vehicle: registration, insurance, roadworthiness test, vignette, service, tyres — by date, by kilometres or by both.',
        add:                    'Add a reminder',
        edit:                   'Edit the reminder',
        delete:                 'Delete the reminder',
        deleted:                'The reminder has been deleted.',
        delete_failed:          'The reminder could not be deleted.',
        confirm_delete:         'Delete the reminder "{title}"?',
        confirm_history:        'Its history of completed work and costs goes with it. To stop it watching instead, switch it off.',
        empty:                  'No reminders.',
        vehicle:                'Vehicle',
        all_vehicles:           'All vehicles',
        type:                   'Type',
        all_types:              'All types',
        title:                  'Title',
        title_help:             'Left empty, the reminder is called after its type.',
        title_too_long:         'The title is too long.',
        note:                   'Note',
        note_too_long:          'The note is too long.',
        active:                 'Active',
        due_date:               'Due',
        due_km:                 'Due at',
        due_help:               'Enter a date, an odometer reading, engine hours or several — the reminder falls due at whichever comes first.',
        needs_due:              'Enter a date, an odometer reading or engine hours.',
        clear_date:             'Clear the date',
        no_odometer:            'This vehicle does not report its odometer; a reminder by kilometres will not work.',
        no_odometer_short:      'This vehicle does not report its odometer.',
        repeat_months:          'Repeat every (months)',
        repeat_km:              'Repeat every (km)',
        lead_days:              'Warn ahead (days)',
        lead_km:                'Warn ahead (km)',
        overdue:                'Overdue',
        due_soon:               'Due soon',
        ok:                     'In order',
        inactive:               'Switched off',
        all:                    'All',
        due_today:              'due today ({date})',
        in_days:                'in {count} day | in {count} days',
        days_ago:               'overdue by {count} day | overdue by {count} days',
        in_km:                  'in {count}',
        km_at:                  'at {at}, now {now}',
        km_over:                'overdue by {count} (at {at})',
        km_unknown:             'at {at} — the vehicle does not report its odometer',
        every_months:           'every {count} month | every {count} months',
        every_km:               'every {count}',
        last_done:              'last done {date}',
        at_km:                  'at {at}',
        complete:               'Mark as done',
        completed:              'The reminder has been recorded as done.',
        complete_failed:        'The completed work could not be saved.',
        done_at:                'Done on',
        done_km:                'Odometer',
        cost:                   'Cost',
        cost_invalid:           'Enter an amount, for example 186.40.',
        next:                   'Next: {next}',
        next_or:                ' or ',
        next_at_km:             'at {at}',
        next_none:              'The reminder switches itself off afterwards and stays as the record of what was done.',
        all_for_vehicle:        'All reminders for this vehicle',
        said_due_soon:          '{name} — due soon',
        said_overdue:           '{name} — overdue',
        type_registration:      'Registration',
        type_insurance:         'Insurance',
        type_inspection:        'Roadworthiness test',
        type_vignette:          'Vignette',
        type_service:           'Service',
        type_tyres:             'Tyres',
        type_custom:            'Custom',
        cost_becomes:           'The amount will be booked as a {category} cost.',
        completed_with_cost:    'Done; the cost of {amount} has been booked.',
        cost_link:              'Cost: {amount}',
        open_cost:              'Open the cost',
        due_hours:              'Due at engine hours',
        repeat_hours:           'Repeat every (engine hours)',
        lead_hours:             'Warn ahead (engine hours)',
        done_hours:             'Engine hours',
        no_engine_hours:        'This vehicle does not report engine hours; a reminder by engine hours will not work.',
        no_engine_hours_short:  'This vehicle does not report engine hours.',
        hours_unknown:          'at {at} — the vehicle does not report engine hours',
    },
    service_case: {
        list_subtitle_operator:    'From the reported fault to the vehicle back in service: every case, its workshop and what it waits for.',
        list_subtitle_customer:    'The service cases of your vehicles and how far they have got.',
        list_subtitle_workshop:    'The cases assigned to you: appointments, quotes, parts and repairs.',
        open_action:               'Report a service',
        report_service:            'Report a service',
        filter_open:               'Open cases',
        filter_all:                'All cases',
        all_vehicles:              'All vehicles',
        all_customers:             'All customers',
        all_workshops:             'All workshops',
        empty:                     'No service cases for this selection.',
        load_older:                'Load older',
        no_more:                   'No older cases.',
        case:                      'Case',
        vehicle:                   'Vehicle',
        customer:                  'Customer',
        workshop:                  'Workshop',
        status:                    'Status',
        opened:                    'Opened',
        waiting:                   'Waiting for',
        waiting_for:               'Waiting for {what}',
        out_for:                   'out of service {time}',
        no_workshop:               'Not assigned',
        days_short:                '{count} d',
        too_long:                  'The text is too long',
        fault_codes_too_many:      'At most {count} codes',
        odometer_invalid:          'The odometer must be between 0 and 10,000,000',
        slots_at_least_one:        'At least one slot is needed',
        slots_too_many:            'At most {count} slots',
        status_reported:           'Reported',
        status_scheduled:          'Scheduled',
        status_in_workshop:        'In the workshop',
        status_quoted:             'Quoted',
        status_approved:           'Approved',
        status_parts_ordered:      'Parts ordered',
        status_parts_received:     'Parts received',
        status_in_repair:          'In repair',
        status_ready:              'Ready for pickup',
        status_picked_up:          'Picked up',
        status_cancelled:          'Cancelled',
        waiting_appointment:       'an appointment',
        waiting_approval:          'approval',
        waiting_parts:             'parts',
        waiting_repair:            'the repair',
        waiting_pickup:            'pickup',
        trigger:                   'Trigger',
        trigger_dtc:               'Fault codes',
        trigger_reminder:          'Reminder',
        trigger_manual:            'Reported problem',
        trigger_renter_report:     'Renter report',
        trigger_return_damage:     'Damage on return',
        step_reported:             'Reported',
        step_scheduled:            'Appointment',
        step_arrived:              'Arrival',
        step_parts:                'Parts',
        step_repair:               'Repair',
        step_ready:                'Ready',
        step_picked_up:            'Picked up',
        subtitle:                  'From the alarm to the pickup',
        odometer:                  'Odometer',
        downtime:                  'Out of service',
        next_step:                 'Next step',
        your_turn:                 'It is your move.',
        whose_turn:                'Waiting for: {party}',
        reader_note:               'You can read this case; an administrator takes the steps.',
        on_behalf:                 'On behalf of',
        offered_slots:             'Offered slots',
        extra_waiting:             'Extra work waiting for a decision',
        approve:                   'Approve',
        reject:                    'Reject',
        party_operator:            'Operator',
        party_customer:            'Customer',
        party_workshop:            'Workshop',
        turn_assign:               'Assigning a workshop',
        turn_slots:                'Proposing appointment slots',
        turn_confirm:              'Confirming an appointment',
        turn_arrival:              'The vehicle arriving at the workshop',
        turn_quote:                'Diagnosis and quote',
        turn_approval:             'Approving the quote',
        turn_extra:                'Deciding on extra work',
        turn_parts_or_repair:      'Ordering parts or starting the repair',
        turn_delivery:             'Delivering the parts',
        turn_start:                'Starting the repair',
        turn_repair:               'Repair in progress',
        turn_pickup:               'Picking up the vehicle',
        turn_done:                 'The vehicle is back in service',
        turn_cancelled:            'The case was cancelled',
        hint_scheduled:            'Appointment: {slot}',
        hint_quoted:               'The workshop\'s quote: {total} excl. VAT.',
        hint_quoted_hidden:        'The workshop has sent its quote for approval.',
        hint_rejected:             'The previous quote was rejected: {reason}',
        action_assign:             'Assign a workshop',
        action_reassign:           'Change the workshop',
        action_propose_slots:      'Propose slots',
        action_confirm_slot:       'Confirm slot',
        action_intake:             'Take the vehicle in',
        action_send_quote:         'Send the quote',
        action_send_quote_again:   'Send a new quote',
        action_approve_quote:      'Approve the quote',
        action_reject_quote:       'Reject the quote',
        action_extra_work:         'Propose extra work',
        action_decide_extra:       'Decide on extra work',
        action_order_parts:        'Order parts',
        action_start_repair:       'Start the repair',
        action_complete_repair:    'Repair complete',
        action_pickup:             'Confirm pickup',
        action_cancel:             'Cancel the case',
        complete_blocked_extra:    'Extra work is still waiting for a decision.',
        complete_blocked_parts:    'Parts are still on their way: mark them received or cancel the order.',
        step_failed:               'The step failed',
        assigned:                  'Workshop assigned',
        slots_sent:                'Slots sent',
        slot_confirmed:            'Slot confirmed',
        intake_done:               'Vehicle taken in',
        quote_sent:                'Quote sent',
        quote_approved_done:       'Quote approved',
        quote_rejected_done:       'Quote rejected',
        extra_sent:                'Extra work proposed',
        extra_approved_done:       'Extra work approved',
        extra_rejected_done:       'Extra work rejected',
        repair_started:            'Repair started',
        completed:                 'Repair complete; the vehicle is ready for pickup',
        picked_up_done:            'Pickup confirmed; the case is closed',
        cancelled_done:            'The case was cancelled',
        confirm_approve:           'Approve the quote of {total} excl. VAT? The workshop can then order parts and start the repair.',
        confirm_pickup:            'Confirm that the vehicle has been picked up? The case closes and the downtime stops.',
        reject_quote_help:         'The workshop will send a new quote. Say what should change.',
        reject_extra:              'Reject the extra work',
        cancel_help:               'A cancelled case is closed; the vehicle returns unrepaired. Open a new case for a new problem.',
        reason:                    'Reason',
        reason_help:               'Optional. The other party reads it.',
        pick_workshop:             'Choose a workshop',
        no_workshops:              'No active workshops. Add one under Organisations.',
        reassign_note:             'A new workshop starts the appointment over: the previous slots are dropped.',
        slots_help:                'Offer one or more slots (up to 10). The customer confirms one of them.',
        slot_start:                'From',
        slot_end:                  'To',
        slot_end_after:            'The end must be after the start',
        slot_too_long:             'A slot can last at most 7 days',
        add_slot:                  'Add a slot',
        send_slots:                'Send the slots',
        slots_offered:             '{count} slot offered | {count} slots offered',
        note:                      'Note',
        intake_help:               'The vehicle has arrived: when, at what reading and in what state.',
        intake_walk_in:            'The vehicle arrived without an appointment (towed in, walk-in) — the intake skips the appointment.',
        intake_at:                 'Taken in at',
        intake_future:             'The intake cannot be in the future',
        intake_note_placeholder:   'Visible damage, fuel, equipment in the car …',
        photos:                    'Photos',
        photos_help:               'JPEG, PNG, WebP or PDF, up to 10 MB each.',
        photos_pick:               'Choose photos',
        photos_drop:               'or drop them here',
        photos_kept:               '{count} photo already uploaded | {count} photos already uploaded',
        photos_uploaded:           '{count} photo uploaded | {count} photos uploaded',
        photo_failed:              'The photo could not be loaded',
        photo_missing:             'Photo not available',
        quote_help:                'The parts and labour the workshop invoices the operator. Amounts exclude VAT; the totals are computed by the platform.',
        quote_note:                'Note to the quote',
        quote_rejected_title:      'The previous quote was rejected',
        send_quote:                'Send the quote',
        extra_help:                'Work found beyond the approved quote. The operator approves or rejects it; a photo helps.',
        extra_description:         'Description',
        extra_amount:              'Amount excl. VAT',
        extra_photo_help:          'A photo proves the work is needed (a worn disc, a leaking hose).',
        send_extra:                'Send for approval',
        complete_help:             'The work is done and the vehicle is ready for pickup. Say what was done.',
        complete_notes:            'What was done',
        open_title:                'Report a service',
        open_help:                 'Opens a service case for the vehicle. The operator assigns a workshop.',
        open_submit:               'Open the case',
        open_failed:               'The case was not opened',
        opened_done:               'Case {code} opened',
        pick_vehicle:              'Choose a vehicle',
        title:                     'Title',
        title_placeholder:         'e.g. Engine light, noisy brakes',
        description:               'Description',
        fault_codes:               'Fault codes',
        fault_codes_help:          'Codes read with a tester, comma-separated (P0301). The tracker sends only their count.',
        fault_code_invalid:        'A fault code: letters, digits and dashes, 2–12 characters',
        odometer_help:             'Empty: the tracker\'s last reading.',
        in_service:                'The vehicle stays in service until it goes in',
        in_service_help:           'The downtime is then counted from the intake rather than from now.',
        from_alert:                'From the alert: {what} — {vehicle}',
        from_reminder:             'From the reminder: {what} — {vehicle}',
        open_existing:             'Open {code}',
        open_case:                 'Open the case',
        open_from_alert:           'Open a service case',
        open_from_reminder:        'Open a service case',
        overview:                  'Case summary',
        coordinator:               'Coordinator',
        appointment:               'Appointment',
        out_of_service:            'Out of service since',
        still_in_service:          'In service until the intake',
        odometer_opened:           'Odometer at the report',
        odometer_intake:           'Odometer at the intake',
        picked_up:                 'Picked up',
        sum_parts:                 'Parts',
        sum_labour:                'Labour',
        sum_extra:                 'Extra work',
        sum_total:                 'Total excl. VAT',
        invoicing_note:            '{operator} invoices the customer; the workshop invoices the operator.',
        prices_hidden:             'The prices are agreed between the operator and the workshop; you are invoiced by the operator.',
        work:                      'Diagnosis and work',
        reported_problem:          'Reported problem',
        intake:                    'Intake',
        quote_version:             'Quote v{version}',
        quote_approved:            'Approved',
        quote_rejected:            'Rejected',
        quote_waiting:             'Waiting for approval',
        quote_sent_by:             'Sent by {name}, {at}',
        quote_approved_by:         'approved by {name}, {at}',
        extra_work:                'Extra work',
        extra_proposed:            'Waiting',
        extra_approved:            'Approved',
        extra_rejected:            'Rejected',
        completion:                'Completion',
        thread:                    'Shared conversation',
        thread_subtitle:           'The operator, the customer and the workshop in one place.',
        thread_empty:              'No messages yet.',
        message_placeholder:       'Write a message … (Ctrl+Enter sends)',
        attach:                    'Attach photos',
        send:                      'Send',
        gallery:                   'Photo documentation',
        gallery_count:             '{count} file | {count} files',
        gallery_empty:             'No photos yet.',
        add_photos:                'Add photos',
        upload:                    'Upload',
        open_original:             'Open the original',
        photo_report:              'Report',
        photo_intake:              'Intake',
        photo_diagnosis:           'Diagnosis',
        photo_extra_work:          'Extra work',
        photo_completion:          'Completion',
        photo_message:             'Message',
        trail:                     'Activity trail',
        trail_empty:               'No activity yet.',
        event_opened:              'Case opened ({trigger})',
        event_workshop_assigned:   'Assigned to {name}',
        event_workshop_reassigned: 'Workshop changed to {name}',
        event_slots_proposed:      '{count} slot proposed | {count} slots proposed',
        event_slot_confirmed:      'Slot confirmed: {slot}',
        event_intake:              'Vehicle taken in',
        event_intake_km:           'Vehicle taken in ({km})',
        event_quote_sent:          'Quote v{version} sent',
        event_quote_approved:      'Quote v{version} approved',
        event_quote_rejected:      'Quote v{version} rejected',
        event_extra_work_proposed: 'Extra work proposed',
        event_extra_work_approved: 'Extra work approved',
        event_extra_work_rejected: 'Extra work rejected',
        event_part_order_created:  'Part order created',
        event_part_order_updated:  'Part order edited',
        event_part_order_moved:    'Part order: {status}',
        event_repair_started:      'Repair started',
        event_repair_completed:    'Repair completed',
        event_picked_up:           'Vehicle picked up',
        event_cancelled:           'Case cancelled',
        event_photo_added:         'Photo added',
        event_photos_added:        '{count} photo added | {count} photos added',
        error_illegal:             'This step is not possible in the case\'s current state — it changed meanwhile and has been reloaded.',
        error_changed:             'Somebody else changed the case meanwhile — it has been reloaded. Look at the change and try again.',
        error_exists:              'The vehicle already has an open service case. Add the new problem to it (a message or extra work).',
        error_not_found:           'The case was not found or is not available to you.',
    },
    line_items: {
        kind:             'Kind',
        kind_part:        'Part',
        kind_labour:      'Labour',
        description:      'Description',
        part_number:      'Part number',
        quantity:         'Quantity',
        hours:            'Hours',
        unit_price:       'Unit price',
        line_total:       'Amount',
        total:            'Total excl. VAT',
        add:              'Add a line',
        add_part:         'Add a part',
        add_labour:       'Add labour',
        quantity_invalid: 'The quantity must be above zero (e.g. 1 or 1.5)',
        price_invalid:    'An amount in euros, at most two decimals (e.g. 45.90)',
        at_least_one:     'At least one line is needed',
        too_many:         'At most {count} lines',
    },
    part_order: {
        orders:                   'Part orders',
        subtitle_operator:        'The workshops\' orders against their cases: place them in your system, confirm with your order number and ship.',
        subtitle_workshop:        'The parts you ordered for your cases.',
        of_case:                  'Part orders',
        none_on_case:             'No part orders on this case yet.',
        empty:                    'No orders in this list.',
        filter_active:            'Active',
        filter_closed:            'Finished',
        closed_capped:            'The last {count} finished orders are shown.',
        status_draft:             'Draft',
        status_submitted:         'Submitted',
        status_confirmed:         'Confirmed',
        status_shipped:           'Shipped',
        status_received:          'Received',
        status_cancelled:         'Cancelled',
        at_created:               'Created',
        at_submitted:             'Submitted',
        at_confirmed:             'Confirmed',
        at_shipped:               'Shipped',
        at_received:              'Received',
        at_cancelled:             'Cancelled',
        add:                      'New part order',
        edit:                     'Edit the order',
        dialog_help:              'The parts you order for this case. You type the prices until the catalogue is connected.',
        note:                     'Note',
        save_draft:               'Save as draft',
        save_and_submit:          'Save and submit',
        draft_saved:              'Draft saved',
        submit:                   'Submit',
        submitted:                'Order submitted',
        confirm:                  'Confirm',
        confirmed:                'Order confirmed',
        external_ref:             'Your order number',
        external_ref_help:        'Optional — the link to the order in your ERP.',
        external_ref_short:       'No. {ref}',
        ship:                     'Ship',
        shipped:                  'Order shipped',
        receive:                  'Mark received',
        received:                 'Parts received',
        cancel:                   'Cancel the order',
        cancelled:                'Order cancelled',
        confirm_cancel_draft:     'Cancel this draft order?',
        confirm_cancel_submitted: 'Cancel this submitted order? The workshop sees it on the case.',
        step_failed:              'The order step failed',
        error_changed:            'Somebody else changed the order meanwhile — it has been reloaded.',
    },
    out_of_service: {
        title:               'Vehicles out of service',
        subtitle:            'Which vehicles are standing and why, and how long a vehicle takes to be back in service.',
        window_days:         '{count} d',
        out_now:             'Out of service now',
        open_cases:          'Open cases',
        opened:              'Opened',
        closed:              'Back in service',
        in_window:           'in the chosen window',
        cancelled_note:      'and {count} cancelled | and {count} cancelled',
        avg_downtime:        'Average to back in service',
        measured:            'over {count} case | over {count} cases',
        waiting_appointment: 'Appointment',
        waiting_approval:    'Approval',
        waiting_parts:       'Parts',
        waiting_repair:      'Repair',
        waiting_pickup:      'Pickup',
        vehicles:            'Vehicles standing',
        vehicles_subtitle:   'Longest out first.',
        none_out:            'No vehicle is out of service right now.',
        downtime:            'Out for',
        since:               'Since {at}',
        by_customer:         'By customer',
        by_workshop:         'By workshop',
        name:                'Name',
        col_out:             'Out now',
        col_open:            'Open',
        col_opened:          'Opened',
        col_closed:          'Back',
        col_avg:             'Average',
        no_rows:             'No data in the window.',
    },
    units: {
        kmh:        'km/h',
        meters:     'm',
        degrees:    '°',
        celsius:    '°C',
        percent:    '%',
        volt:       'V',
        km:         'km',
        ampere:     'A',
        kwh:        'kWh',
        kwh_100km:  'kWh/100 km',
        litre:      'l',
        kw:         'kW',
        rpm:        'rpm',

        rpm_x1000:  '× 1000 rpm',
    },
    /*
     * The installation guide (`views/guide/`). Prose only: Configurator's own labels, the
     * AVL ids and the wiki addresses are the same in every language and live in
     * `libs/guide.ts`; this deployment's address comes from GET /install-info. The console's
     * own labels (menu entries, buttons, states) are passed in from their own keys, so the
     * guide always names them the way the screen does.
     */
    guide: {
        title:   'Installation guide',
        heading: 'Setting up a Teltonika FMC003',
        lede:    'How to prepare a new FMC003 so that it sends its data to this console: from the SIM card and Teltonika Configurator to checking the first drive. Field names are given as Configurator shows them, in English.',
        values: {
            title:         'Values to type',
            domain:        'Server (Domain)',
            port:          'Port',
            protocol:      'Protocol',
            data_protocol: 'Data protocol',
            unknown:       'This console does not know the public address trackers send their data to. Ask an administrator for the address and the port before you start.',
            unknown_admin: 'The address is set in the stanic-api service’s environment, as TRACKER_PUBLIC_HOST and TRACKER_PUBLIC_PORT. Until both are set, the guide shows no address.',
            ask:           'ask an administrator',
        },
        col: {
            field:     'Field',
            value:     'Value',
            note:      'Note',
            on_stop:   'Parked (On Stop)',
            on_moving: 'Driving (On Moving)',
            symptom:   'Symptom',
            cause:     'Most likely cause',
        },
        value: {
            per_operator: 'from the operator',
            default:      'default',
        },
        before: {
            title:    'Before you start',
            device:   'The FMC003 and its IMEI (15 digits, on the label of the device and on the box).',
            sim:      'A micro-SIM card with a data plan and the PIN turned off. From the operator you need the APN name, and with some operators a username and password as well.',
            computer: 'A Windows computer with the latest {configurator}, Teltonika’s USB drivers (COM port drivers) and a micro-USB cable. Bluetooth can be used instead of the cable.',
            account:  'An administrator account in the console.',
        },
        add: {
            title:      'Add the vehicle to the console',
            intro:      'The server accepts only trackers whose IMEI has been entered in the console. A tracker that has not been entered is refused on its very first connection, even when everything else is set up correctly.',
            open:       'In the console, open {vehicles} and choose {add}.',
            fill:       'Enter the IMEI, the vehicle’s name and its registration plate. For electric and hybrid vehicles choose the drivetrain as well, so that the console shows the right instruments.',
            save:       'Save. The server picks up a new IMEI within 30 seconds.',
            imei_title: 'The IMEI is the only protection.',
            imei_body:  'The server recognises a tracker by its IMEI and nothing else, so do not share IMEIs outside the team. Delete a tracker that is no longer used in the console: that stops it connecting straight away.',
            reader:     'You are signed in as a reader: only an administrator can add a vehicle. Send them the IMEI, the vehicle’s name and its registration plate.',
        },
        sim: {
            title: 'Insert the SIM card',
            power: 'Insert and remove the SIM only while the tracker is switched off, out of the OBD socket. Inserting it under power can damage the device.',
            pin:   'The SIM card’s PIN must be turned off. If that is not possible, the PIN is entered in Configurator.',
        },
        connect: {
            title:        'Connect the tracker to Configurator',
            usb_title:    'With a USB cable',
            usb_drivers:  'Install Teltonika’s COM port drivers (Windows x64 only).',
            usb_connect:  'Connect the FMC003 with a micro-USB cable and start Configurator. The tracker appears in the list; select it.',
            bt_title:     'Over Bluetooth',
            bt_on:        'Bluetooth is on by default on the FMC003. The tracker advertises itself as {prefix} followed by the last seven digits of its IMEI.',
            bt_pair:      'Pair it with the computer. The default pairing PIN is {pin}.',
            before_title: 'Before changing anything',
            backup:       'Click {load}, then {save} to keep the original configuration.',
            firmware:     'If Configurator offers new firmware, update it ({update}). Reading OEM data from the vehicle needs firmware {version} or newer.',
        },
        gprs: {
            title:         'GPRS: APN and server',
            apn:           'The APN name of the SIM card’s data plan.',
            apn_login:     'Most operators do not need them; leave them empty then.',
            domain:        'The public address of the server that receives the data.',
            protocol:      'The server does not accept UDP.',
            tls:           'Off.',
            second_server: 'No backup server is used.',
            ack:           'The server acknowledges received records the standard Teltonika way.',
        },
        system: {
            title:             'System: protocol and sleep',
            data_protocol:     'Required. Only Codec 8 Extended carries parameters with an id above 255, such as the vehicle’s odometer (389).',
            sleep:             'The tracker stays connected to the network and the GPS switches off while the vehicle is standing. The console shows such a vehicle as “{asleep}”.',
            without_ts:        'Records without an accurate time are not sent.',
            static_navigation: 'Stops the position “jumping” while the vehicle is standing.',
            sources:           'For electric vehicles, see the note in step 07.',
        },
        acquisition: {
            title:   'Data Acquisition: how often it sends',
            path:    'Configurator › Data Acquisition › Home (repeat the same for Roaming if the vehicle goes abroad)',
            intro:   'The console shows a vehicle as “{offline}” when nothing has arrived from its tracker for {minutes} min. The sending period while parked must therefore be shorter than that.',
            derived: 'The parked period ({period} s) is worked out from this console’s settings: a third of that time, rounded down to a whole minute, at most 300 s.',
            outro:   'These values give a smooth line on the map and a live view about ten seconds behind, and a standing vehicle sends about {per_day} records a day instead of several thousand.',
        },
        obd: {
            title:         'OBD II and OEM data from the vehicle',
            feature:       'For vehicles with a combustion engine.',
            feature_ev:    'For electric vehicles. Standard OBD queries on an electric vehicle return meaningless values (the coolant temperature, for example); this mode uses only the manufacturer’s OEM parameters.',
            vin:           'If the VIN does not arrive, enter it by hand (Manual).',
            params_title:  'Parameters the console uses',
            params_intro:  'On the {io} tab (and in the OBD/OEM lists), enable the following parameters with priority {low}. The console stores everything the tracker sends, but these are the ones it shows on the instruments, in the trips and in the alerts.',
            params_outro:  'Which OEM parameters a vehicle actually sends depends on its make and model. A parameter the vehicle does not support simply never arrives, and the console then does not show it.',
        },
        param: {
            ignition:         'key on or off',
            movement:         'moving or not',
            external_voltage: 'car battery',
            dtc_count:        'number of faults',
            fault_codes:      'the fault codes',
            oem_mileage:      'the car’s own km',
        },
        install: {
            title: 'Save and install',
            save:  'Click {save}, then {reboot}.',
            file:  'Save the new configuration to a file as well ({save_file}). The same file can later be loaded onto the next trackers ({load_file}, then {save}), after which only the APN needs checking.',
            plug:  'Plug the tracker into the vehicle’s OBD socket. It must sit where it does not get in the driver’s way. If the socket is in an awkward place, use an OBD extension cable.',
        },
        check: {
            title:      'Check in the console',
            online:     'In the console, open {vehicles} and the vehicle. Within a few minutes its state changes to “{online}” and “{last_record}” shows the current time.',
            parameters: 'On the {parameters} tab, check that ignition (239) and the battery voltage (66) arrive and, if the vehicle supports them, the VIN (256) and the vehicle’s odometer (389).',
            drive:      'Take a short test drive. On the {map} page the vehicle should show as driving, and once the drive is over it appears on the {trips} page and on the vehicle’s page.',
            ok_title:   'All is well when…',
            ok_body:    'the vehicle has the right position on the {map} page, moves every ten seconds or so while driving, and after parking goes to “{stopped}” and then “{asleep}”.',
        },
        trouble: {
            title:                'If something does not work',
            never_seen:           'The vehicle stays “{never_seen}”',
            never_seen_cause:     'The IMEI has not been entered in the console, or has been entered wrongly; the APN is wrong; the SIM card’s PIN is not turned off; UDP was chosen instead of TCP, or the port is wrong.',
            offline_parked:       '“{offline}” while the vehicle is standing',
            offline_parked_cause: 'The parked sending period (On Stop) is longer than {minutes} min, or a sleep mode was chosen in which the tracker disconnects from the network (Deep Sleep, Ultra Deep Sleep).',
            no_oem:               'No vehicle odometer and no battery data',
            no_oem_cause:         'Enable the OEM parameters on the I/O tab and update the firmware. For electric vehicles, set OBD Feature to Non-Compliant.',
            impossible:           'The instruments show impossible values',
            impossible_cause:     'An electric vehicle on OBD (Auto): the standard engine parameters mean nothing there. Switch to Non-Compliant.',
            km:                   'The kilometres are wrong',
            km_cause:             'The vehicle does not send the OEM odometer (389), so the console uses the tracker’s own GPS counter (16), which starts from zero when it is installed.',
        },
        sources: {
            title:       'Sources',
            intro:       'Field names and default values follow Teltonika’s documentation:',
            first_start: 'FMC003 First Start',
            gprs:        'GPRS settings',
            system:      'System settings',
            acquisition: 'Data acquisition',
            obd:         'OBD II settings',
            parameters:  'Parameter list',
            note:        'Configurator may look slightly different depending on the version of the program and of the firmware.',
        },
    },
}
